import React, { VFC } from 'react';
import styled from 'styled-components';
import { IIconProps } from './types';

const Wrapper = styled.div`
  display: block;
  margin: auto auto;
`;

const ChevronDownIcon: VFC<IIconProps> = ({ color }) => (
  <Wrapper>
    <svg width={12} height={7} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m1 1 5 5 5-5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Wrapper>
);

export default ChevronDownIcon;
